var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-empty-state',{attrs:{"md-icon":"error","md-label":"Access Denied","md-description":"We are sorry, you do not have permission to view the request content."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }